export default __webpack_public_path__ + "static/media/24356 - Parv Sarin.28a21040.jpeg";